module.exports = __webpack_public_path__ + "img/right.fe927ed.png";